import { ArrowDownIcon } from '@cian/ui-kit/prev';
import * as React from 'react';
import classNames from 'classnames';

import * as styles from './selectButton.css';
import { EVisualSize, ISelectStyles, TSelectButtonAppearance } from '../types';
import { getInlineStyles } from './helpers';

const APPEARANCE_TO_CLASS_MAP: { [key in TSelectButtonAppearance]: string } = {
  default: styles['button'],
  underlined: styles['button-underlined'],
};

interface ISelectButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  active: boolean;
  invalid?: boolean;
  size?: EVisualSize;
  style?: ISelectStyles;
  appearance?: TSelectButtonAppearance;
  withoutArrow?: boolean;
}

export const SelectButton = ({
  active,
  children,
  invalid,
  size,
  style,
  appearance = 'default',
  withoutArrow,
  ...htmlButtonProps
}: ISelectButtonProps) => (
  <button
    {...htmlButtonProps}
    type="button"
    className={classNames(
      APPEARANCE_TO_CLASS_MAP[appearance],
      active && styles['active'],
      invalid && styles['invalid'],
      size === EVisualSize.DESKTOP && styles['desktop'],
      size === EVisualSize.MOBILE && styles['mobile'],
    )}
    style={getInlineStyles(style)}
  >
    <span className={styles['content']}>{children}</span>

    {!withoutArrow && (
      <ArrowDownIcon
        __classNames={classNames(styles['icon'])}
        custom={{
          size: '11',
        }}
        styles={{
          color: htmlButtonProps.disabled ? 'C9C9C9' : '2B87DB',
        }}
      />
    )}
  </button>
);
